import axios from "axios";
export const isLocal = window.location.hostname === "localhost";
export const backendBaseUrl = isLocal ? "http://localhost:5000" : "https://www.trendscout.club";

export const api = axios.create({ baseURL: backendBaseUrl });

export function authHeaders() {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}
